<template>
  <div v-if="article && card">
    <div class="flex items-center pb-4">
      <h1 class="flex-grow pb-0">
        <router-link :to="{name: 'cards'}">Cartes AS24</router-link>
        &nbsp;>&nbsp;
        {{card.identifier}}<br>
      </h1>
      <router-link
        tag="button"
        class="mf-primary-button ml-3"
        :to="{name: 'editCard', params: {id: card.id}}">
        Modifier
      </router-link>
    </div>
    <div class="mf-container">
      <div class="md:flex">
        <div class="mt-4 md:mt-0 flex-grow">
          <h2 class="pb-1 inline-block">
            Carte AS24
            <span class="text-gray-500 ml-2">N° {{card.identifier}}</span>
            <span v-if="card.isLost" class="text-red-400 ml-2">PERDU / USÉ</span>
          </h2>
          <div class="text-gray-600">
            Valable jusqu’en {{card.validity}}
          </div>
        </div>
        <div class="md:ml-3 rounded-lg px-2 h-20 text-center leading-none font-semibold bg-indigo-100 text-indigo-500 justify-center items-center flex flex-col">
          <span class="mb-2 text-2xl">{{card.code}}</span>
          <span class="text-sm text-blue-600">Code</span>
        </div>
      </div>
    </div>
    <article-operation-groups :article="article" :card="card" />
    <article-employees :employees="employees" />
  </div>
</template>

<script>
import ArticleOperationGroups from '@components/ArticleOperationGroups'
import ArticleEmployees from '@components/ArticleEmployees'

export default {
  components: { ArticleOperationGroups, ArticleEmployees },
  data() {
    return {
      article: null,
      card: null
    }
  },
  computed: {
    employees() {
      return this.card.employee ? [this.card.employee] : []
    }
  },
  async created() {
    const { id } = this.$route.params
    try {
      this.card = await this.$store.dispatch('cards/getCard', id)
      this.article = await this.$store.dispatch('articles/getArticleByName', 'Carte AS24')
    }
    catch (e) {
      this.$router.push({ name: 'stock' })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
